












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Alert } from '@b2x/authentication-library';
import { Logger, AlertType } from '@b2x/common';

enum AlertIcon {
  ERROR = 'alert-circle',
  SUCCESS = 'checkmark-circle',
  WARNING = 'alert-circle',
  HIGHLIGHT = 'bds/info-circle/24',
}

@Component({
  name: 'user-alert',
})
export default class UserAlert extends Vue {
  @Prop({
    default: null,
    type: Object,
  })
  alert!: Alert | null;

  logger = new Logger('USER_ALERT_COMPONENT');

  get alertType() {
    const { type = AlertType.HIGHLIGHT } = this.alert || ({} as Alert);
    return type.toLowerCase();
  }

  get alertIcon() {
    const { type = AlertType.HIGHLIGHT } = this.alert || ({} as Alert);
    return AlertIcon[type];
  }

  get alertMessage() {
    const { message = '' } = this.alert || ({} as Alert);
    return message;
  }

  handlerDismiss(event: CustomEvent) {
    this.logger.log('Alert dismiss triggered');
    this.$emit('onDismiss', event);
  }
}
